import { useTranslation } from "react-i18next"

import { SHARED_PROJECT_DETAILS } from "shared/constants/permalinks"
import { raiseToast } from "shared/lib/toast/raiseToast"
import { useEvent } from "shared/lib/useEvent"
import { ToastType } from "shared/types/Toast"

import { useCreateShareLinkMutation } from "features/project-sharing/graphql/mutations.generated"

export function getShareLinkFromShareID(shareID: string | null | undefined) {
  if (!shareID) return null
  return `${window.location.origin}/${SHARED_PROJECT_DETAILS}?shared_project_id=${shareID}`
}

export function useGetProjectShareLink(id: string) {
  const { t } = useTranslation()

  const [createShareLink] = useCreateShareLinkMutation({
    variables: { id, input: { id } }
  })
  const handleCreateShareLink = useEvent(() =>
    createShareLink().then(({ data }) =>
      getShareLinkFromShareID(data?.shareLink.id)
    )
  )

  const copyShareLink = useEvent(() =>
    handleCreateShareLink().then(link => {
      if (link) {
        navigator.clipboard.writeText(link)
      } else {
        raiseToast({
          message: t("Project.ShareLinkGenerateError"),
          type: ToastType.ERROR
        })
      }
    })
  )

  return { createShareLink: handleCreateShareLink, copyShareLink }
}
